import { Instagram, Linkedin, Facebook } from "lucide-react";
import { NAV_LINKS, EMAIL } from "@/data/site";
import { goToAnchor } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t hairline pt-20 pb-10 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <p className="font-display font-light text-[12vw] leading-[0.85] tracking-tight text-ivory/[0.07] select-none whitespace-nowrap" aria-hidden="true">
          VCONTRACTZ
        </p>

        <div className="mt-14 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-4">
              <img src="/assets/vsipl-logo.png" alt="VSIPL — Vcontractz Solutions India Pvt. Ltd. logo" className="h-14 w-auto" />
              <p className="text-sm font-semibold tracking-[0.4em] text-ivory">VCONTRACTZ<span className="text-gold">.</span></p>
            </div>
            <p className="mt-4 text-sm text-muted font-light">Premium Real Estate Visual Post-Production</p>
            <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-bronze">Precision. Atmosphere. Perfection.</p>
          </div>

          <nav className="md:col-span-3" aria-label="Footer">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={() => goToAnchor(l.href)}
                    className="text-sm text-ivory/70 hover:text-gold transition-colors duration-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <button data-testid="footer-link-faq" onClick={() => goToAnchor("#faq")} className="text-sm text-ivory/70 hover:text-gold transition-colors duration-300">
                  FAQ
                </button>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted mb-5">Connect</p>
            <div className="flex gap-4">
              <a data-testid="footer-social-instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 border hairline flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/50 transition-colors duration-300">
                <Instagram size={16} />
              </a>
              <a data-testid="footer-social-linkedin" href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-10 h-10 border hairline flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/50 transition-colors duration-300">
                <Linkedin size={16} />
              </a>
              <a data-testid="footer-social-facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 border hairline flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/50 transition-colors duration-300">
                <Facebook size={16} />
              </a>
            </div>
            <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="mt-6 inline-block text-sm text-ivory/70 hover:text-gold transition-colors duration-300">
              {EMAIL}
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted mb-5">Legal</p>
            <ul className="space-y-3">
              <li><a data-testid="footer-privacy-link" href="#top" onClick={(e) => e.preventDefault()} className="text-sm text-ivory/70 hover:text-gold transition-colors duration-300">Privacy Policy</a></li>
              <li><a data-testid="footer-terms-link" href="#top" onClick={(e) => e.preventDefault()} className="text-sm text-ivory/70 hover:text-gold transition-colors duration-300">Terms &amp; Conditions</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t hairline flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] text-muted tracking-wide">
            &copy; 2026 Vcontractz Solutions India Pvt. Ltd. All Rights Reserved.
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted/60">
            Real Estate Visual Post-Production — Worldwide
          </p>
        </div>
      </div>
    </footer>
  );
}
